export default __webpack_public_path__ + "3cea07560c3b5d8c109239b45c224e7f.jpg";